module.exports = __webpack_public_path__ + "img/System-3-logo-horizontal-BLKGRN.715ec373.png";